import type { PlaceEntity } from '@this/domain/place/place.type';

export default class Place {
  components: PlaceEntity['address_components'];

  location: PlaceEntity['location'];

  info?: PlaceEntity['info'];

  prefectureName: string | null;

  municipalityName: string | null;

  countryCode: string | null;

  isDomestic: boolean;

  constructor(entity: PlaceEntity) {
    this.components = entity.address_components;
    this.location = entity.location;
    this.info = entity.info;

    this.prefectureName = this.findPrefectureName();
    this.municipalityName = this.findMunicipalityName();
    this.countryCode = this.findCountryCode();
    this.isDomestic = this.hasDomesticComponent();
  }

  private findPrefectureName(): string | null {
    const component = this.components.find(a => a.types.includes('administrative_area_level_1'));
    return component ? component.long_name : null;
  }

  private findMunicipalityName(): string | null {
    const component = this.components.find(a => a.types.includes('locality'));
    return component ? component.long_name : null;
  }

  private findCountryCode(): string | null {
    const component = this.components.find(a => a.types.includes('country'));
    return component ? component.short_name : null;
  }

  private hasDomesticComponent() {
    return this.components.some(component => component.types.includes('country') && component.short_name === 'JP');
  }
}
